// @flow
import React, { useState } from 'react';
import strings from 'strings';
import type { ProfileDataTableProps } from 'types/app';
import ProfileTableLayout from 'UI/components/organisms/inventoryProfiles/ProfileTableLayout';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';
import { TabKeys } from 'UI/constants/entityTypes';

import { ChangeLogsContent } from './ChangeLogsContent';
import { ChangeLogsColumns } from './columns';

type ChangeLogsTabProps = {
  DataTableProps: ProfileDataTableProps,
  tablePreferencesKey: string,
  entityId: number,
  profileModule: string
};

const ChangeLogsTab = ({
  DataTableProps,
  profileModule,
  entityId,
  tablePreferencesKey
}: ChangeLogsTabProps) => {
  const [uiState, setUiState] = useState({
    isChangeLogOpen: false,
    selectedChangeLogId: null
  });

  const handleChangeLogClick = (changeLogId: number) => {
    setUiState({
      isChangeLogOpen: true,
      selectedChangeLogId: changeLogId
    });
  };

  const handleCloseDrawer = () =>
    setUiState({
      isChangeLogOpen: false,
      selectedChangeLogId: null
    });

  const finalActions = [
    {
      name: 'view',
      callback: handleChangeLogClick,
      pickId: true
    }
  ];

  const changeLogContentEndpoint =
    DataTableProps?.endpoint &&
    `${DataTableProps?.endpoint}/${uiState.selectedChangeLogId}?includes=vCreatedBy`;

  return (
    <>
      <ProfileTableLayout
        DataTableProps={DataTableProps}
        finalActions={finalActions}
        initialColumns={ChangeLogsColumns}
        orderByOptions={{ column: 'created_at', direction: 'desc' }}
        profileModule={profileModule}
        search={false}
        tabKey={TabKeys.ChangeLogs}
        tablePreferencesKey={tablePreferencesKey}
      />
      {entityId && (
        <FPDrawer
          onClose={handleCloseDrawer}
          CardHeaderProps={{
            title: strings.inventoryProfiles.sections.tabs.changeLogs.sectionName
          }}
          FPDrawerProps={{ open: uiState.isChangeLogOpen }}
        >
          <div role="presentation">
            {uiState.selectedChangeLogId && (
              <ChangeLogsContent endpoint={changeLogContentEndpoint} />
            )}
          </div>
        </FPDrawer>
      )}
    </>
  );
};

export default ChangeLogsTab;
